// import React, { useState, useEffect, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import "./newFeePlan.css";
// import "./editFeePlan.css";
// import "../CreateQuestionsPaper/TestScheduling/testscheduling.css";
// import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
// import DropDown from "../../Components/Shared/Dropdown/Dropdown";
// import EndPoints from "../../Api/EndPoints";
// import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
// import InfoIcon from "../../Assets/Images/CommanImages/Informative.png";
// import MinusImg from "../../Assets/Images/CommanImages/MinusGrey.png";
// import YellowPlus from "../../Assets/Images/CommanImages/YellowPlus.png";
// import MaleImg from "../../Assets/Images/EployeeRegistration/male_avatar.png";
// import FemaleImg from "../../Assets/Images/EployeeRegistration/female_avater.png";

// // ---------------------------------------------------------------------------
// // Helpers (same conventions as NewFeePlan.jsx)
// // ---------------------------------------------------------------------------

// const todayStr = () => new Date().toISOString().split("T")[0];

// const nextDayStr = (dateStr) => {
//   const d = new Date(dateStr);
//   d.setDate(d.getDate() + 1);
//   return d.toISOString().split("T")[0];
// };

// const maxDueDateStr = () => {
//   const d = new Date();
//   d.setFullYear(d.getFullYear() + 5);
//   return d.toISOString().split("T")[0];
// };

// const formatINR = (num) => {
//   const n = Number(num);
//   if (isNaN(n)) return "0.00";
//   return n.toLocaleString("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });
// };

// const installmentTaxBreakup = (instAmount, sgstRate, cgstRate) => {
//   const base = Number(instAmount) || 0;
//   const sgst = (base * (Number(sgstRate) || 0)) / 100;
//   const cgst = (base * (Number(cgstRate) || 0)) / 100;
//   return { sgst, cgst, totalGst: sgst + cgst, grossAmount: base + sgst + cgst };
// };

// // Inst Amount is now the directly-editable field; Percentage is derived
// // from it (of the pre-tax net fee base) purely for display.
// const derivePercentage = (amount, netFeeBase) => {
//   const base = Number(netFeeBase) || 0;
//   if (base <= 0) return "";
//   const pct = (Number(amount) / base) * 100;
//   return Number.isFinite(pct) ? pct.toFixed(2) : "";
// };

// const PAYMENT_MODE_LABELS = {
//   1: "Cash",
//   2: "Cheque",
//   3: "NEFT/IMPS",
//   4: "UPI",
//   5: "Refund Adjustment",
//   6: "Demand Draft",
//   7: "Credit Card",
//   8: "ECS",
//   9: "NACH",
//   10: "Online Gateway",
//   11: "Bank Deposit",
//   12: "Fee Waiver",
// };

// const emptyInstallmentsRow = () => [
//   {
//     key: `inst_1_${Date.now()}`,
//     fee_schedule_id: null,
//     installment_no: 1,
//     due_date: "",
//     amount: "",
//     remarks: "",
//   },
// ];

// const SectionHeader = ({ title, isOpen, onToggle }) => (
//   <div className="Header-1-C424342 nfp-section-header">
//     <span>{title}</span>
//     {isOpen ? (
//       <img src={MinusImg} alt="Toggle" className="nfp-toggle-icon" onClick={onToggle} />
//     ) : (
//       <div className="plus nfp-toggle-plus" onClick={onToggle}>
//         +
//       </div>
//     )}
//   </div>
// );

// // ---------------------------------------------------------------------------
// // Component
// // ---------------------------------------------------------------------------

// function EditFeePlan({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setNoTimeSet,
//   setShowCloseButton,
// }) {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
//   const employeeName =
//     [
//       dataClient?.client_schema_name?.[6]?.[0]?.emp_first_name,
//       dataClient?.client_schema_name?.[6]?.[0]?.emp_last_name,
//     ]
//       .filter(Boolean)
//       .join(" ") || userName;
//   const instituteName = dataClient?.client_schema_name?.[6]?.[0]?.client_display_name || "";
//   const branchName = dataClient?.client_schema_name?.[6]?.[0]?.br_display_name || "";

//   const studentId = new URLSearchParams(location.search).get("studentId");

//   // ---- Page state ----
//   const [isLoading, setIsLoading] = useState(true);
//   const [loadError, setLoadError] = useState("");
//   const [isEditing, setIsEditing] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [showError, setShowError] = useState(false);

//   // ---- Section collapse state ----
//   const [sectionOpen, setSectionOpen] = useState({
//     student: true,
//     fee: true,
//     installments: true,
//     payments: true,
//   });
//   const toggleSection = (key) =>
//     setSectionOpen((prev) => ({ ...prev, [key]: !prev[key] }));

//   // ---- Student profile ----
//   const [studentProfile, setStudentProfile] = useState(null);
//   const [studentPhotoUrl, setStudentPhotoUrl] = useState(null);

//   // ---- Sessions + all of the student's fee plans across sessions ----
//   const [sessionsList, setSessionsList] = useState([]);
//   const [allPlans, setAllPlans] = useState([]); // every fee plan this student has, any session
//   const [selectedSessionId, setSelectedSessionId] = useState(null);

//   // ---- Fee plan identity ----
//   const [feePlanId, setFeePlanId] = useState(null);
//   const [accStudentId, setAccStudentId] = useState(null); // carried through as-is, not editable here
//   const [registrationFormNo, setRegistrationFormNo] = useState("");
//   const [pristineSnapshot, setPristineSnapshot] = useState(null);

//   // ---- Fee breakdown ----
//   const [totalFee, setTotalFee] = useState("");
//   const [scholarship, setScholarship] = useState("");
//   const [discount, setDiscount] = useState("");
//   const [defaultSgst, setDefaultSgst] = useState("9");
//   const [defaultCgst, setDefaultCgst] = useState("9");

//   // ---- Batch Type (editable - prefilled from the student's enquiry,
//   // but course_fees is now split by batch type, so changing it needs
//   // to re-fetch the applicable fees) ----
//   const [batchTypes, setBatchTypes] = useState([]);
//   const [selectedBatchType, setSelectedBatchType] = useState(null);

//   // ---- Installments ----
//   const [installments, setInstallments] = useState([]);

//   // ---- Additional ----
//   const [approvedBy, setApprovedBy] = useState("");
//   const [remarks, setRemarks] = useState("");

//   // ---- Payment history ----
//   // Full history for the student (every session/plan) - filtered down to
//   // the selected session's plan for both display and paid-installment
//   // locking, using fee_schedule_id to trace each payment back. Compared
//   // as strings since the two APIs backing this (get-student-fee-plan and
//   // get-student-fee-payment-history) aren't guaranteed to serialize the
//   // same numeric id as the same JS type (Set/strict-equality otherwise
//   // silently never matches - same class of bug as the session dropdown).
//   const [fullPaymentHistory, setFullPaymentHistory] = useState([]);

//   const paymentHistory = React.useMemo(() => {
//     const idsForThisPlan = new Set(
//       installments
//         .map((i) => (i.fee_schedule_id != null ? String(i.fee_schedule_id) : null))
//         .filter(Boolean)
//     );
//     return fullPaymentHistory.filter(
//       (p) => p.fee_schedule_id != null && idsForThisPlan.has(String(p.fee_schedule_id))
//     );
//   }, [fullPaymentHistory, installments]);

//   const paidFeeScheduleIds = React.useMemo(
//     () =>
//       new Set(
//         fullPaymentHistory
//           .map((p) => (p.fee_schedule_id != null ? String(p.fee_schedule_id) : null))
//           .filter(Boolean)
//       ),
//     [fullPaymentHistory]
//   );

//   const isCurrentSession = selectedSessionId != null &&
//     studentProfile?.session_id != null &&
//     Number(selectedSessionId) === Number(studentProfile.session_id);

//   const selectedSession = sessionsList.find(
//     (s) => Number(s.session_id) === Number(selectedSessionId)
//   );
//   const sessionStartDate = selectedSession?.session_start_date
//     ? selectedSession.session_start_date.split(" ")[0]
//     : "";
//   const sessionEndDate = selectedSession?.session_end_date
//     ? selectedSession.session_end_date.split(" ")[0]
//     : "";

//   const netFeeBase = Math.max(
//     0,
//     (Number(totalFee) || 0) - (Number(scholarship) || 0) - (Number(discount) || 0)
//   );
//   const sgstAmount = (netFeeBase * (Number(defaultSgst) || 0)) / 100;
//   const cgstAmount = (netFeeBase * (Number(defaultCgst) || 0)) / 100;
//   const totalGstAmount = sgstAmount + cgstAmount;
//   const netFee = netFeeBase + totalGstAmount;

//   const totalAlreadyPaid = paymentHistory.reduce(
//     (sum, p) => sum + (Number(p.amount) || 0) + (Number(p.sgst) || 0) + (Number(p.cgst) || 0),
//     0
//   );

//   const installmentTotals = installments.reduce(
//     (acc, inst) => {
//       const instAmount = Number(inst.amount) || 0;
//       const { sgst, cgst, totalGst, grossAmount } = installmentTaxBreakup(
//         instAmount,
//         defaultSgst,
//         defaultCgst
//       );
//       acc.instAmount += instAmount;
//       acc.sgst += sgst;
//       acc.cgst += cgst;
//       acc.totalGst += totalGst;
//       acc.grossAmount += grossAmount;
//       return acc;
//     },
//     { instAmount: 0, sgst: 0, cgst: 0, totalGst: 0, grossAmount: 0 }
//   );

//   const notify = (message, isError = true) => {
//     setShowCloseButton(false);
//     if (isError) setNoTimeSet && setNoTimeSet(false);
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX" style={{ width: "100%" }}>
//         <div className="messagebox-insider1" style={{ width: "100%" }}>
//           <span>{message}</span>
//         </div>
//       </div>
//     );
//     setActiveImg(isError ? ErrorImg : InfoIcon);
//   };

//   // Same shared message box used for errors/warnings/save messages -
//   // shown while the page's initial data is loading.
//   const showLoading = (text) => {
//     setNoTimeSet && setNoTimeSet(true);
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span style={{ marginLeft: "10px", marginTop: "3px" }}>{text}</span>
//         </div>
//       </div>
//     );
//     setActiveImg(false);
//   };

//   // ---------------------------------------------------------------------
//   // Populate the fee/installments sections from a given plan - or clear
//   // them to blank if this session has no plan on record yet.
//   // ---------------------------------------------------------------------
//   const applyPlanForSession = (sessionId, plansList) => {
//     const plan = plansList
//       .filter((p) => Number(p.session_id) === Number(sessionId))
//       .sort((a, b) => b.fee_plan_id - a.fee_plan_id)[0];

//     if (!plan) {
//       setFeePlanId(null);
//       setAccStudentId(null);
//       setRegistrationFormNo("");
//       setTotalFee("");
//       setScholarship("");
//       setDiscount("");
//       setDefaultSgst("9");
//       setDefaultCgst("9");
//       setApprovedBy("");
//       setRemarks("");
//       setInstallments(emptyInstallmentsRow());
//       setPristineSnapshot(
//         JSON.stringify({
//           accStudentId: "",
//           registrationFormNo: "",
//           totalFee: "",
//           scholarship: "",
//           discount: "",
//           approvedBy: "",
//           remarks: "",
//           installments: [{ due_date: "", amount: "", remarks: "" }],
//         })
//       );
//       return;
//     }

//     const planNetFeeBase = Math.max(
//       0,
//       (Number(plan.total_fee_inr) || 0) -
//         (Number(plan.scholarship_amount) || 0) -
//         (Number(plan.discount_amount) || 0)
//     );

//     if (plan.sgst == null || plan.cgst == null) {
//       notify(
//         "This fee plan is missing its SGST/CGST rate from the server - can't load it safely. Please check the plan's data before continuing."
//       );
//       return;
//     }

//     setFeePlanId(plan.fee_plan_id);
//     setAccStudentId(plan.acc_student_id ?? null);
//     setRegistrationFormNo(plan.reg_form_no ?? "");
//     setTotalFee(plan.total_fee_inr ?? "");
//     setScholarship(plan.scholarship_amount ?? "");
//     setDiscount(plan.discount_amount ?? "");
//     setDefaultSgst(derivePercentage(plan.sgst, planNetFeeBase));
//     setDefaultCgst(derivePercentage(plan.cgst, planNetFeeBase));
//     setApprovedBy(plan.approved_by || "");
//     setRemarks(plan.remarks || "");

//     const loadedInstallments = (plan.fee_schedule_list || [])
//       .slice()
//       .sort((a, b) => a.installment_no - b.installment_no)
//       .map((sched) => ({
//         key: `inst_${sched.installment_no}_${Date.now()}_${Math.random()
//           .toString(36)
//           .slice(2, 6)}`,
//         fee_schedule_id: sched.fee_schedule_id ?? null,
//         installment_no: sched.installment_no,
//         due_date: sched.due_date || "",
//         amount: sched.amount != null ? String(sched.amount) : "",
//         remarks: sched.remarks || "",
//       }));

//     setInstallments(loadedInstallments.length ? loadedInstallments : emptyInstallmentsRow());

//     setPristineSnapshot(
//       JSON.stringify({
//         accStudentId: plan.acc_student_id ?? "",
//         registrationFormNo: plan.reg_form_no ?? "",
//         totalFee: String(plan.total_fee_inr ?? ""),
//         scholarship: String(plan.scholarship_amount ?? ""),
//         discount: String(plan.discount_amount ?? ""),
//         approvedBy: plan.approved_by || "",
//         remarks: plan.remarks || "",
//         installments: (loadedInstallments.length
//           ? loadedInstallments
//           : [{ due_date: "", amount: "", remarks: "" }]
//         ).map((i) => ({
//           due_date: i.due_date,
//           amount: String(i.amount ?? ""),
//           remarks: i.remarks || "",
//         })),
//       })
//     );
//   };

//   const handleSessionChange = (sessionId) => {
//     setSelectedSessionId(sessionId);
//     setIsEditing(false);
//     setShowError(false);
//     applyPlanForSession(sessionId, allPlans);
//   };

//   // ---------------------------------------------------------------------
//   // Load: student profile + sessions + all fee plans + payment history
//   // ---------------------------------------------------------------------
//   const loadData = async () => {
//     if (!studentId) {
//       setLoadError("No student was specified. Go back and select a student to edit.");
//       setIsLoading(false);
//       return;
//     }

//     setIsLoading(true);
//     setLoadError("");
//     setIsEditing(false);
//     setShowError(false);
//     showLoading("Loading data, please wait...");

//     try {
//       const token = localStorage.getItem("other");
//       const [profileRes, planRes, sessionsRes] = await Promise.all([
//         fetch(`${EndPoints.GET_STUDENT_ADMISSION_PROFILE}?student_id=${studentId}`, {
//           headers: { accept: "application/json", Authorization: `Bearer ${token}` },
//         }).then((r) => r.json()),
//         fetch(`${EndPoints.GET_STUDENT_FEE_PLAN}?student_id=${studentId}`, {
//           headers: { accept: "application/json", Authorization: `Bearer ${token}` },
//         }).then((r) => r.json()),
//         fetch(EndPoints.GET_SESSIONS_LIST, {
//           headers: { accept: "application/json" },
//         }).then((r) => r.json()),
//       ]);

//       const profile = profileRes?.data?.[0];
//       if (profileRes?.status === 200 && profile) {
//         setStudentProfile(profile);
//         if (profile.class_id != null && profile.course_id != null) {
//           fetchBatchTypes(profile.class_id, profile.course_id);
//         }
//         setSelectedBatchType(profile.batch_type_id ?? null);
//         if (profileRes?.signed_url && profileRes.signed_url !== "URL not found") {
//           setStudentPhotoUrl(profileRes.signed_url);
//         }
//       } else {
//         setStudentProfile(null);
//       }

//       const sessions = Array.isArray(sessionsRes?.data)
//         ? sessionsRes.data
//         : Array.isArray(sessionsRes)
//         ? sessionsRes
//         : [];
//       setSessionsList(sessions);

//       const plans = Array.isArray(planRes?.data) ? planRes.data : [];
//       setAllPlans(plans);

//       // Default to the student's current session - falls back to
//       // whichever plan is most recent if the current session can't be
//       // determined for some reason.
//       const defaultSessionId =
//         profile?.session_id ??
//         (plans.length
//           ? [...plans].sort((a, b) => b.fee_plan_id - a.fee_plan_id)[0].session_id
//           : null);

//       setSelectedSessionId(defaultSessionId);

//       if (defaultSessionId != null) {
//         applyPlanForSession(defaultSessionId, plans);
//       } else if (!plans.length) {
//         setLoadError(
//           "No fee plan exists for this student yet, and no session could be determined. You can create one instead."
//         );
//       }

//       // Payment history is supplementary/read-only - don't block the page
//       // Fetched once for the whole student; filtered down to the
//       // selected session's plan for display via fee_schedule_id. A
//       // failure here shouldn't block the rest of the page loading, so
//       // it just falls back to an empty history rather than surfacing
//       // an error on it if it fails.
//       try {
//         const historyRes = await fetch(
//           `${EndPoints.GET_STUDENT_FEE_PAYMENT_HISTORY}?student_id=${studentId}`,
//           { headers: { accept: "application/json", Authorization: `Bearer ${token}` } }
//         ).then((r) => r.json());
//         setFullPaymentHistory(Array.isArray(historyRes?.data) ? historyRes.data : []);
//       } catch (err) {
//         console.error("Error fetching payment history:", err);
//         setFullPaymentHistory([]);
//       }

//       setIsLoading(false);
//       setIsMessageBoxVisible(false);
//     } catch (err) {
//       console.error("Error loading fee plan:", err);
//       setLoadError("Something went wrong while loading this fee plan. Please try again.");
//       setIsLoading(false);
//       setIsMessageBoxVisible(false);
//     }
//   };

//   // Batch Type options are scoped to the student's (class, course).
//   const fetchBatchTypes = async (classId, courseId) => {
//     if (classId == null || courseId == null) {
//       setBatchTypes([]);
//       return;
//     }
//     try {
//       const res = await fetch(
//         `${EndPoints.GET_BATCH_TYPES}?class_id=${classId}&course_id=${courseId}`,
//         { headers: { accept: "application/json" } }
//       );
//       const data = await res.json();
//       setBatchTypes(Array.isArray(data?.data) ? data.data : []);
//     } catch (err) {
//       console.error("Error fetching batch types:", err);
//       setBatchTypes([]);
//     }
//   };

//   // Batch Type changed on the form - re-fetch course fees for the newly
//   // selected batch type and overwrite the fee fields with them, rather
//   // than leaving whatever the existing plan (or the previous batch
//   // type) had.
//   const handleBatchTypeChange = async (batchTypeId) => {
//     setSelectedBatchType(batchTypeId);
//     if (!studentId) return;
//     try {
//       const token = localStorage.getItem("other");
//       const feesResponse = await fetch(
//         `${EndPoints.GET_COURSE_FEES_FOR_STUDENT}?student_id=${studentId}&batch_type=${batchTypeId}`,
//         { headers: { accept: "application/json", Authorization: `Bearer ${token}` } }
//       );
//       const feesData = await feesResponse.json();
//       if (feesData?.status === 200 && feesData?.data) {
//         setDefaultSgst(feesData.data.sgst_prcnt);
//         setDefaultCgst(feesData.data.cgst_prcnt);
//         setTotalFee(feesData.data.base_fees);
//       } else {
//         notify(
//           "No SGST/CGST rate is configured for this course/session/branch/class/batch type combination - please contact your administrator to configure this."
//         );
//       }
//     } catch (err) {
//       console.error("Error fetching course fees:", err);
//       notify(
//         "No SGST/CGST rate is configured for this course/session/branch/class/batch type combination - please contact your administrator to configure this."
//       );
//     }
//   };

//   useEffect(() => {
//     loadData();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [studentId]);

//   // ---------------------------------------------------------------------
//   // Installments
//   // ---------------------------------------------------------------------
//   const handleAddInstallment = () => {
//     if (installments.length >= 12) {
//       notify("A fee plan can have at most 12 installments.");
//       return;
//     }
//     setInstallments((prev) => {
//       const nextNo = prev.length
//         ? Math.max(...prev.map((i) => i.installment_no)) + 1
//         : 1;
//       return [
//         ...prev,
//         {
//           key: `inst_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
//           fee_schedule_id: null,
//           installment_no: nextNo,
//           due_date: "",
//           amount: "",
//           remarks: "",
//         },
//       ];
//     });
//   };

//   // The add-installment button only shows while the last row is being
//   // written in - tracked via focus bubbling up from its fields (React's
//   // onFocus/onBlur bubble even though FormInputs doesn't forward these
//   // as props). Blur hides it after a short delay rather than
//   // immediately, so a click on the button itself (which briefly blurs
//   // the field first) still has time to register before it disappears.
//   const [isLastRowActive, setIsLastRowActive] = useState(false);
//   const lastRowBlurTimeoutRef = useRef(null);
//   const handleLastRowFocus = () => {
//     if (lastRowBlurTimeoutRef.current) clearTimeout(lastRowBlurTimeoutRef.current);
//     setIsLastRowActive(true);
//   };
//   const handleLastRowBlur = () => {
//     lastRowBlurTimeoutRef.current = setTimeout(() => setIsLastRowActive(false), 200);
//   };

//   const handleRemoveInstallment = (key) => {
//     // Renumbering here used to reassign installment_no for every
//     // remaining row sequentially - which could shift a *paid*
//     // installment's number if an unpaid one before it was removed. The
//     // backend's paid-installment protection matches by installment_no,
//     // so that shift made it look like the paid installment itself had
//     // been removed, incorrectly blocking the save. Numbers are left as
//     // they are now - a gap in the sequence is a minor cosmetic
//     // tradeoff for not silently corrupting a paid installment's
//     // identity.
//     setInstallments((prev) => prev.filter((inst) => inst.key !== key));
//   };

//   const handleInstallmentField = (key, field, value) => {
//     setInstallments((prev) =>
//       prev.map((inst) => (inst.key === key ? { ...inst, [field]: value } : inst))
//     );
//   };

//   // ---------------------------------------------------------------------
//   // Edit / Cancel / Print
//   // ---------------------------------------------------------------------
//   const handleEdit = () => setIsEditing(true);

//   // True once the person has actually changed something from what was
//   // loaded - used to decide whether Cancel needs to confirm at all.
//   const isFormDirty = () => {
//     if (pristineSnapshot === null) return false;
//     const currentSnapshot = JSON.stringify({
//       accStudentId: accStudentId || "",
//       registrationFormNo: registrationFormNo || "",
//       totalFee: String(totalFee ?? ""),
//       scholarship: String(scholarship ?? ""),
//       discount: String(discount ?? ""),
//       approvedBy: approvedBy || "",
//       remarks: remarks || "",
//       installments: installments.map((i) => ({
//         due_date: i.due_date,
//         amount: String(i.amount ?? ""),
//         remarks: i.remarks || "",
//       })),
//     });
//     return currentSnapshot !== pristineSnapshot;
//   };

//   const handleCancel = () => {
//     if (!isFormDirty()) {
//       navigate("/fee_plan_dashboard");
//       return;
//     }

//     setShowCloseButton(false);
//     setNoTimeSet(true); // keep the box open (it normally auto-closes after 3.5s) until Yes/No is clicked
//     setIsMessageBoxVisible(true);
//     setActiveImg(ErrorImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span>Are you sure you want to cancel? Unsaved changes will be lost.</span>
//         </div>
//         <div className="messagebox-insider2" style={{ display: "flex", gap: "10px" }}>
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => {
//               setIsMessageBoxVisible(false);
//               setNoTimeSet(false);
//               navigate("/fee_plan_dashboard");
//             }}
//           >
//             Yes
//           </button>
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => {
//               setIsMessageBoxVisible(false);
//               setNoTimeSet(false);
//             }}
//           >
//             No
//           </button>
//         </div>
//       </div>
//     );
//   };

//   const handlePrint = () => {
//     const originalTitle = document.title;
//     // Browsers use document.title both as the default "Save as PDF"
//     // filename AND as the print header text at the top of the page -
//     // there's no way to set one without the other from the page, so a
//     // meaningful save filename necessarily means this text also shows
//     // at the top when printed.
//     const studentName = studentProfile?.student_full_name || "Student";
//     const rollNo = studentProfile?.Roll_Number || "";
//     document.title = `${(studentName + rollNo).replace(/[,\s]/g, "")}_feeplan`;
//     window.print();
//     document.title = originalTitle;
//   };

//   // ---------------------------------------------------------------------
//   // Save (create-student-fee-plan when this session has no plan yet,
//   // update-student-fee-plan otherwise)
//   // ---------------------------------------------------------------------
//   const handleSave = async () => {
//     setShowError(true);

//     if (!studentId || selectedSessionId == null) {
//       notify("Missing student/session reference. Please reload the page and try again.");
//       return;
//     }
//     if (!studentProfile?.course_id) {
//       notify("Course details are unavailable for this student.");
//       return;
//     }
//     if (!totalFee || Number(totalFee) <= 0) {
//       notify("Please enter a valid Total Base Fee.");
//       return;
//     }
//     if (installments.length === 0) {
//       notify("Please add at least one installment.");
//       return;
//     }
//     for (const inst of installments) {
//       if (!inst.due_date || !inst.amount || Number(inst.amount) <= 0) {
//         notify("Please complete the due date and amount for every installment.");
//         return;
//       }
//       if (Number(derivePercentage(inst.amount, netFeeBase)) > 100) {
//         notify(`Installment ${inst.installment_no}'s amount can't be more than the net fee (100%).`);
//         return;
//       }
//       if (inst.due_date < todayStr()) {
//         notify(
//           `Installment ${inst.installment_no}'s due date can't be in the past - it must be today or later.`
//         );
//         return;
//       }
//       if (sessionEndDate && inst.due_date > sessionEndDate) {
//         notify(
//           `Installment ${inst.installment_no}'s due date can't be after the session's end date (${sessionEndDate}).`
//         );
//         return;
//       }
//     }
//     for (let i = 1; i < installments.length; i++) {
//       if (installments[i].due_date <= installments[i - 1].due_date) {
//         notify(
//           `Installment ${installments[i].installment_no}'s due date must be later than installment ${installments[i - 1].installment_no}'s due date.`
//         );
//         return;
//       }
//     }
//     if (Math.abs(installmentTotals.instAmount - netFeeBase) > 1) {
//       notify(
//         `Installment amounts (₹ ${formatINR(
//           installmentTotals.instAmount
//         )}) do not add up to the Net Fee (₹ ${formatINR(
//           netFeeBase
//         )}). Please adjust the installment amount to match net fee.`
//       );
//       return;
//     }
//     if ((Number(scholarship) > 0 || Number(discount) > 0) && !remarks.trim()) {
//       notify("Remarks are required when a scholarship or concession is applied.");
//       return;
//     }
//     if (totalAlreadyPaid > netFee) {
//       notify(
//         `Total amount already paid against this plan (₹ ${formatINR(
//           totalAlreadyPaid
//         )}) exceeds the new Net Fee (₹ ${formatINR(
//           netFee
//         )}). Net Fee can't be reduced below what has already been collected.`
//       );
//       return;
//     }
//     if (!userName) {
//       notify("Unable to determine the logged-in user. Please re-login and try again.");
//       return;
//     }

//     const isCreatingNewPlan = !feePlanId;

//     const fee_schedule_list = installments.map((inst) => {
//       const instAmount = Number(inst.amount) || 0;
//       const breakup = installmentTaxBreakup(instAmount, defaultSgst, defaultCgst);
//       return {
//         installment_no: inst.installment_no,
//         due_date: inst.due_date,
//         amount: Number(instAmount),
//         sgst: breakup.sgst,
//         cgst: breakup.cgst,
//         remarks: inst.remarks || null,
//       };
//     });

//     const payload = isCreatingNewPlan
//       ? {
//           student_id: Number(studentId),
//           session_id: Number(selectedSessionId),
//           course_id: Number(studentProfile.course_id),
//           reg_form_no: registrationFormNo || null,
//           total_fee_inr: Number(totalFee),
//           scholarship_amount: Number(scholarship) || 0,
//           discount_amount: Number(discount) || 0,
//           net_fee: Number(netFee),
//           sgst: sgstAmount,
//           cgst: cgstAmount,
//           remarks: remarks || null,
//           approved_by: approvedBy || null,
//           username: userName,
//           fee_schedule_list,
//         }
//       : {
//           fee_plan_id: Number(feePlanId),
//           student_id: Number(studentId),
//           session_id: Number(selectedSessionId),
//           course_id: Number(studentProfile.course_id),
//           acc_student_id: accStudentId ?? null,
//           reg_form_no: registrationFormNo || null,
//           total_fee_inr: Number(totalFee),
//           scholarship_amount: Number(scholarship) || 0,
//           discount_amount: Number(discount) || 0,
//           net_fee: Number(netFee),
//           sgst: sgstAmount,
//           cgst: cgstAmount,
//           remarks: remarks || null,
//           approved_by: approvedBy || null,
//           username: userName,
//           fee_schedule_list,
//         };

//     setIsSubmitting(true);
//     try {
//       const token = localStorage.getItem("other");
//       const response = await fetch(
//         isCreatingNewPlan ? EndPoints.CREATE_STUDENT_FEE_PLAN : EndPoints.UPDATE_STUDENT_FEE_PLAN,
//         {
//           method: isCreatingNewPlan ? "POST" : "PUT",
//           headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//           body: JSON.stringify(payload),
//         }
//       );
//       const data = await response.json();

//       if (data?.status === 200) {
//         notify(data.message || "Fee plan saved successfully.", false);
//         setIsEditing(false);
//         setShowError(false);
//         loadData();
//       } else {
//         notify(data?.message || "Failed to save the fee plan.");
//       }
//     } catch (err) {
//       console.error("Error saving fee plan:", err);
//       notify("An error occurred while saving the fee plan.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const printDate = new Date().toLocaleDateString("en-GB");
//   // Locked whenever not actively editing, OR the selected session isn't
//   // the student's current one - past/future sessions are view-only, no
//   // way to enter edit mode for them at all (see the Edit button below).
//   const locked = !isEditing || !isCurrentSession;

//   // ---------------------------------------------------------------------
//   // Loading / error states
//   // ---------------------------------------------------------------------
//   if (isLoading) {
//     return (
//       <div className="nfp-container">
//         <div className="efp-state-wrap">
//           <div className="efp-state-title">Loading fee plan…</div>
//         </div>
//       </div>
//     );
//   }

//   if (loadError && allPlans.length === 0) {
//     return (
//       <div className="nfp-container">
//         <div className="efp-state-wrap">
//           <div className="efp-state-title">{loadError}</div>
//           <button
//             className="create-test-section-btn"
//             onClick={() => navigate("/new_fee_plan")}
//           >
//             CREATE NEW FEE PLAN
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="nfp-container">
//       <div className="nfp-page">
//         <div className="nfp-page-header">
//           <div className="nfp-page-title">Fee Plan</div>
//           <div className="nfp-header-btns">
//             <button
//               className="create-test-section-btn"
//               style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//               onClick={handlePrint}
//             >
//               PRINT
//             </button>
//             <button
//               className="create-test-section-btn"
//               style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//               onClick={handleCancel}
//               disabled={isSubmitting}
//             >
//               CANCEL
//             </button>
//             {isEditing ? (
//               <button
//                 className="create-test-section-btn"
//                 style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//                 onClick={handleSave}
//                 disabled={isSubmitting}
//               >
//                 {isSubmitting ? "SAVING..." : "SAVE"}
//               </button>
//             ) : (
//               isCurrentSession && (
//                 <button
//                   className="create-test-section-btn"
//                   style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//                   onClick={handleEdit}
//                 >
//                   EDIT
//                 </button>
//               )
//             )}
//           </div>
//         </div>

//         {/* ---------------- Student & Course Details ---------------- */}
//         <div className="nfp-section">
//           <SectionHeader
//             title="STUDENT & COURSE DETAILS"
//             isOpen={sectionOpen.student}
//             onToggle={() => toggleSection("student")}
//           />
//           {sectionOpen.student && (
//             <div className="Body-1-C424342 nfp-section-body">
//               {studentProfile ? (
//                 <>
//                   <div className="nfp-grid-3">
//                     <FormInputs
//                       label="Student"
//                       disabled
//                       value={studentProfile?.student_full_name || ""}
//                     />
//                     <FormInputs
//                       label="Roll No"
//                       disabled
//                       value={studentProfile?.Roll_Number || ""}
//                     />
//                     <FormInputs label="Batch" disabled value={studentProfile?.Batch || ""} />
//                   </div>

//                   <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
//                     <div className="formInput">
//                       <label>
//                         Batch Type
//                         <span>*</span>
//                       </label>
//                       <DropDown
//                         selected={selectedBatchType}
//                         setSelected={handleBatchTypeChange}
//                         options={batchTypes.map((bt) => ({
//                           id: bt.batch_type_id,
//                           label: bt.batch_type_desc,
//                         }))}
//                         placeholder={batchTypes.length === 0 ? "No batch types for this class" : "Select batch type"}
//                         disabled={locked || batchTypes.length === 0}
//                         Height="auto"
//                         minheight="150px"
//                         OverFlow="auto"
//                       />
//                     </div>
//                     <FormInputs
//                       label="Class"
//                       disabled
//                       value={studentProfile?.Class_name || ""}
//                     />
//                     <FormInputs
//                       label="Course"
//                       disabled
//                       value={studentProfile?.Course_Name || ""}
//                     />
//                   </div>

//                   <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
//                     <FormInputs
//                       label="Father/Mother/Guardian"
//                       disabled
//                       value={
//                         studentProfile?.father_name ||
//                         studentProfile?.mother_name ||
//                         studentProfile?.guardian_name ||
//                         ""
//                       }
//                     />
//                     <div className="formInput">
//                       <label>Session</label>
//                       <DropDown
//                         selected={selectedSessionId}
//                         setSelected={handleSessionChange}
//                         options={sessionsList.map((s) => ({
//                           id: s.session_id,
//                           label: s.session_name,
//                         }))}
//                         Height="auto"
//                         minheight="150px"
//                         OverFlow="auto"
//                       />
//                     </div>
//                     <FormInputs
//                       label="Enquiry Date"
//                       disabled
//                       value={studentProfile?.admission_date || ""}
//                     />
//                   </div>

//                   <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
//                     <FormInputs
//                       label="Account Student ID"
//                       disabled={locked}
//                       placeholder="Enter Ledger / Account ID"
//                       value={accStudentId || ""}
//                       maxLength={10}
//                       onChange={(e) => setAccStudentId(e.target.value.replace(/\D/g, ""))}
//                     />
//                   </div>
//                 </>
//               ) : (
//                 <div className="efp-state-message">Student details unavailable.</div>
//               )}
//             </div>
//           )}
//         </div>

//         {/* ---------------- Fee Details ---------------- */}
//         <div className="nfp-section">
//           <SectionHeader
//             title="FEE DETAILS"
//             isOpen={sectionOpen.fee}
//             onToggle={() => toggleSection("fee")}
//           />
//           {sectionOpen.fee && (
//             <div className="Body-1-C424342 nfp-section-body">
//               <div className="nfp-grid-3">
//                 <FormInputs
//                   label="Total Base Fee (₹)"
//                   required
//                   showError={showError}
//                   disabled={locked}
//                   type="number"
//                   min="0"
//                   step="0.01"
//                   placeholder="0.00"
//                   value={totalFee}
//                   onChange={(e) => setTotalFee(e.target.value)}
//                 />
//                 <FormInputs
//                   label="Scholarship (₹)"
//                   disabled={locked}
//                   type="number"
//                   min="0"
//                   step="0.01"
//                   placeholder="0.00"
//                   value={scholarship}
//                   onChange={(e) => setScholarship(e.target.value)}
//                 />
//                 <FormInputs
//                   label="Concession (₹)"
//                   disabled={locked}
//                   type="number"
//                   min="0"
//                   step="0.01"
//                   placeholder="0.00"
//                   value={discount}
//                   onChange={(e) => setDiscount(e.target.value)}
//                 />
//               </div>

//               <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
//                 <FormInputs label="Net Fee (₹)" value={`${formatINR(netFeeBase)}`} disabled />
//                 <FormInputs label="SGST (₹)" value={`${formatINR(sgstAmount)}`} disabled />
//                 <FormInputs label="CGST (₹)" value={`${formatINR(cgstAmount)}`} disabled />
//               </div>

//               <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
//                 <FormInputs
//                   label="Total Fees Payable (₹)"
//                   value={`${formatINR(netFee)}`}
//                   disabled
//                 />
//                 <FormInputs
//                   label="Approved By"
//                   disabled={locked}
//                   placeholder="Name of approving authority"
//                   value={approvedBy}
//                   maxLength={10}
//                   onChange={(e) => setApprovedBy(e.target.value)}
//                 />
//                 <FormInputs
//                   label="Remarks"
//                   disabled={locked}
//                   placeholder="Add any notes regarding this fee plan..."
//                   value={remarks}
//                   maxLength={500}
//                   onChange={(e) => setRemarks(e.target.value)}
//                   required={Number(scholarship) > 0 || Number(discount) > 0}
//                   showError={showError}
//                 />
//               </div>

//               <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
//                 <FormInputs
//                   label="Registration Form No."
//                   disabled={locked}
//                   placeholder="Enter registration form number"
//                   value={registrationFormNo}
//                   maxLength={10}
//                   onChange={(e) => setRegistrationFormNo(e.target.value)}
//                 />
//               </div>
//             </div>
//           )}
//         </div>

//         {/* ---------------- Installment Schedule ---------------- */}
//         <div className="nfp-section">
//           <div className="Header-1-C424342 nfp-section-header">
//             <span>INSTALLMENT SCHEDULE</span>
//             {sectionOpen.installments ? (
//               <img
//                 src={MinusImg}
//                 alt="Toggle"
//                 className="nfp-toggle-icon"
//                 onClick={() => toggleSection("installments")}
//               />
//             ) : (
//               <div
//                 className="plus nfp-toggle-plus"
//                 onClick={() => toggleSection("installments")}
//               >
//                 +
//               </div>
//             )}
//           </div>

//           {sectionOpen.installments && (
//             <div className="Body-1-C424342 nfp-section-body nfp-section-body-flush">
//               <div className="nfp-table-wrap">
//                 <table className="nfp-table">
//                   <thead>
//                     <tr>
//                       {isEditing && <th style={{ width: "48px" }}></th>}
//                       <th style={{ width: "60px" }}>Inst. No</th>
//                       <th>Due Date</th>
//                       <th>Inst Amount (₹)</th>
//                       <th>Percentage (%)</th>
//                       <th>SGST (₹)</th>
//                       <th>CGST (₹)</th>
//                       <th>Total GST (₹)</th>
//                       <th>Gross Inst Amount (₹)</th>
//                       <th>Remarks</th>
//                       <th>Status</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {installments.map((inst, idx) => {
//                       const instAmount = Number(inst.amount) || 0;
//                       const breakup = installmentTaxBreakup(
//                         instAmount,
//                         defaultSgst,
//                         defaultCgst
//                       );
//                       // Already has a payment recorded against it - can't be
//                       // changed or removed, even while otherwise editing.
//                       const isPaid =
//                         inst.fee_schedule_id &&
//                         paidFeeScheduleIds.has(String(inst.fee_schedule_id));
//                       const rowLocked = locked || isPaid;
//                       const isLastRow = idx === installments.length - 1;
//                       const previousDueDate = idx > 0 ? installments[idx - 1].due_date : null;
//                       const minDueDate =
//                         previousDueDate && nextDayStr(previousDueDate) > todayStr()
//                           ? nextDayStr(previousDueDate)
//                           : todayStr();
//                       return (
//                         <tr
//                           key={inst.key}
//                           onFocus={isLastRow ? handleLastRowFocus : undefined}
//                           onBlur={isLastRow ? handleLastRowBlur : undefined}
//                         >
//                           {isEditing && (
//                             <td className="nfp-row-remove">
//                               <div className="nfp-row-remove-spacer"></div>
//                               {installments.length > 1 && !isPaid && (
//                                 <span
//                                   className="nfp-remove-btn"
//                                   onClick={() => handleRemoveInstallment(inst.key)}
//                                   title="Remove installment"
//                                 >
//                                   ×
//                                 </span>
//                               )}
//                             </td>
//                           )}
//                           <td className="nfp-inst-no">{inst.installment_no}</td>
//                           <td>
//                             <FormInputs
//                               label=""
//                               type="date"
//                               required
//                               showError={showError}
//                               disabled={rowLocked}
//                               min={minDueDate}
//                               max={sessionEndDate || maxDueDateStr()}
//                               value={inst.due_date}
//                               onChange={(e) =>
//                                 handleInstallmentField(inst.key, "due_date", e.target.value)
//                               }
//                             />
//                           </td>
//                           <td>
//                             <FormInputs
//                               label=""
//                               type="number"
//                               required
//                               showError={showError}
//                               disabled={rowLocked}
//                               min="0"
//                               step="0.01"
//                               placeholder="0"
//                               value={inst.amount}
//                               onChange={(e) =>
//                                 handleInstallmentField(inst.key, "amount", e.target.value)
//                               }
//                             />
//                           </td>
//                           <td>
//                             <FormInputs
//                               label=""
//                               value={`${derivePercentage(inst.amount, netFeeBase)}`}
//                               disabled
//                             />
//                           </td>
//                           <td>
//                             <FormInputs label="" value={`${formatINR(breakup.sgst)}`} disabled />
//                           </td>
//                           <td>
//                             <FormInputs label="" value={`${formatINR(breakup.cgst)}`} disabled />
//                           </td>
//                           <td>
//                             <FormInputs
//                               label=""
//                               value={`${formatINR(breakup.totalGst)}`}
//                               disabled
//                             />
//                           </td>
//                           <td>
//                             <FormInputs
//                               label=""
//                               value={`${formatINR(breakup.grossAmount)}`}
//                               disabled
//                             />
//                           </td>
//                           <td>
//                             <FormInputs
//                               label=""
//                               placeholder="Optional"
//                               disabled={rowLocked}
//                               value={inst.remarks}
//                               className="nfp-remarks-input"
//                               onChange={(e) =>
//                                 handleInstallmentField(inst.key, "remarks", e.target.value)
//                               }
//                             />
//                           </td>
//                           <td style={{ textAlign: "center" }}>
//                             {isPaid ? (
//                               <span className="efp-paid-badge" title="Already paid - locked">
//                                 Paid
//                               </span>
//                             ) : (
//                               "-"
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                     {isEditing && !locked && isLastRowActive && (
//                       <tr className="nfp-add-installment-row-inline">
//                         <td colSpan={10}></td>
//                         <td style={{ textAlign: "right" }}>
//                           <img
//                             src={YellowPlus}
//                             alt="Add installment"
//                             className="nfp-add-icon"
//                             onMouseDown={(e) => e.preventDefault()}
//                             onClick={handleAddInstallment}
//                             title="Add installment"
//                           />
//                         </td>
//                       </tr>
//                     )}
//                     <tr className="nfp-total-row">
//                       {isEditing && <td></td>}
//                       <td colSpan={2}>Total</td>
//                       <td>₹ {formatINR(installmentTotals.instAmount)}</td>
//                       <td></td>
//                       <td>₹ {formatINR(installmentTotals.sgst)}</td>
//                       <td>₹ {formatINR(installmentTotals.cgst)}</td>
//                       <td>₹ {formatINR(installmentTotals.totalGst)}</td>
//                       <td>₹ {formatINR(installmentTotals.grossAmount)}</td>
//                       <td></td>
//                       <td></td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>

//               <div className="nfp-installment-total-row">
//                 <span>Net Fee Payable: ₹ {formatINR(netFee)}</span>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* ---------------- Payment History (read-only) ---------------- */}
//         <div className="nfp-section">
//           <SectionHeader
//             title="PAYMENT HISTORY"
//             isOpen={sectionOpen.payments}
//             onToggle={() => toggleSection("payments")}
//           />
//           {sectionOpen.payments && (
//             <div className="Body-1-C424342 nfp-section-body nfp-section-body-flush">
//               {paymentHistory.length === 0 ? (
//                 <div className="efp-payment-empty">
//                   No payments recorded yet for this session's plan.
//                 </div>
//               ) : (
//                 <div className="nfp-table-wrap">
//                   <table className="nfp-table">
//                     <thead>
//                       <tr>
//                         <th>Payment Date</th>
//                         <th>Amount (₹)</th>
//                         <th>SGST (₹)</th>
//                         <th>CGST (₹)</th>
//                         <th>Due Amount (₹)</th>
//                         <th>Mode</th>
//                         <th>Transaction No</th>
//                         <th>Bank Name</th>
//                         <th>Received By</th>
//                         <th>Remarks</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {paymentHistory.map((p, idx) => (
//                         <tr key={idx}>
//                           <td>{p.payment_date || "-"}</td>
//                           <td>₹ {formatINR(p.amount)}</td>
//                           <td>₹ {formatINR(p.sgst)}</td>
//                           <td>₹ {formatINR(p.cgst)}</td>
//                           <td>₹ {formatINR(p.due_amt)}</td>
//                           <td>{PAYMENT_MODE_LABELS[p.payment_mode_id] || "-"}</td>
//                           <td>{p.transaction_no || "-"}</td>
//                           <td>{p.bank_name || "-"}</td>
//                           <td>{p.received_by || "-"}</td>
//                           <td className="nfp-remarks-cell">{p.remarks || "-"}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* ---------------- Print-only fee statement (hidden on screen) ---------------- */}
//       {/* Two copies on one A4 portrait page - the first includes a
//           Parent/Guardian Signature line in the footer, the second
//           doesn't, per request. */}
//       <div className="nfp-print-only">
//         {[true, false].map((showSignature, copyIdx) => (
//         <div className="nfp-print-copy" key={copyIdx}>
//         <div className="nfp-print-box">
//           <div className="nfp-print-header">
//             <div className="nfp-print-header-side"></div>
//             <div className="nfp-print-header-center">
//               <div className="nfp-print-institute">{instituteName || "Fee Statement"}</div>
//               {branchName && <div className="nfp-print-branch">{branchName}</div>}
//               <div className="nfp-print-title">Statement for Fee</div>
//             </div>
//             <div className="nfp-print-header-side"></div>
//           </div>

//           <table className="nfp-print-table">
//             <tbody>
//               <tr>
//                 <td className="nfp-print-label">Student Name</td>
//                 <td>{studentProfile?.student_full_name || "-"}</td>
//                 <td className="nfp-print-label">Roll No.</td>
//                 <td>{studentProfile?.Roll_Number || "-"}</td>
//               </tr>
//               <tr>
//                 <td className="nfp-print-label">Course / Batch</td>
//                 <td className="nfp-print-wrap">
//                   {studentProfile?.Course_Name || "-"} / {studentProfile?.Batch || "-"}
//                 </td>
//                 <td className="nfp-print-label">Session</td>
//                 <td>{selectedSession?.session_name || studentProfile?.session || "-"}</td>
//               </tr>
//               <tr>
//                 <td className="nfp-print-label">Statement Date</td>
//                 <td>{printDate}</td>
//                 <td className="nfp-print-label">Status</td>
//                 <td>{studentProfile?.status || "-"}</td>
//               </tr>
//             </tbody>
//           </table>

//           <table className="nfp-print-table">
//             <colgroup>
//               <col style={{ width: "14%" }} />
//               <col style={{ width: "11%" }} />
//               <col style={{ width: "10%" }} />
//               <col style={{ width: "10%" }} />
//               <col style={{ width: "12%" }} />
//               <col style={{ width: "11%" }} />
//               <col style={{ width: "11%" }} />
//               <col style={{ width: "10%" }} />
//               <col style={{ width: "11%" }} />
//             </colgroup>
//             <thead>
//               <tr>
//                 <th>Particulars</th>
//                 <th>Total Base Fee</th>
//                 <th>Scholarship</th>
//                 <th>Concession</th>
//                 <th>Net Fee</th>
//                 <th>SGST ({defaultSgst || 0}%)</th>
//                 <th>CGST ({defaultCgst || 0}%)</th>
//                 <th>Total GST</th>
//                 <th>Final Fee Amount</th>
//               </tr>
//             </thead>
//             <tbody>
//               <tr>
//                 <td>Coaching Fee</td>
//                 <td>₹ {formatINR(totalFee)}</td>
//                 <td>₹ {formatINR(scholarship)}</td>
//                 <td>₹ {formatINR(discount)}</td>
//                 <td>₹ {formatINR(netFeeBase)}</td>
//                 <td>₹ {formatINR(sgstAmount)}</td>
//                 <td>₹ {formatINR(cgstAmount)}</td>
//                 <td>₹ {formatINR(totalGstAmount)}</td>
//                 <td>
//                   <strong>₹ {formatINR(netFee)}</strong>
//                 </td>
//               </tr>
//             </tbody>
//           </table>

//           <table className="nfp-print-table">
//             <colgroup>
//               <col style={{ width: "6%" }} />
//               <col style={{ width: "12%" }} />
//               <col style={{ width: "12%" }} />
//               <col style={{ width: "9%" }} />
//               <col style={{ width: "11%" }} />
//               <col style={{ width: "11%" }} />
//               <col style={{ width: "11%" }} />
//               <col style={{ width: "13%" }} />
//               <col style={{ width: "15%" }} />
//             </colgroup>
//             <thead>
//               <tr>
//                 <th>Inst. No</th>
//                 <th>Due Date</th>
//                 <th>Inst Amount</th>
//                 <th className="nfp-print-nowrap">%</th>
//                 <th>SGST</th>
//                 <th>CGST</th>
//                 <th>Total GST</th>
//                 <th>Gross Inst Amount</th>
//                 <th>Remarks</th>
//               </tr>
//             </thead>
//             <tbody>
//               {installments.map((inst) => {
//                 const instAmount = Number(inst.amount) || 0;
//                 const breakup = installmentTaxBreakup(instAmount, defaultSgst, defaultCgst);
//                 return (
//                   <tr key={inst.key}>
//                     <td>{inst.installment_no}</td>
//                     <td>{inst.due_date || "-"}</td>
//                     <td className="nfp-print-nowrap">₹ {formatINR(instAmount)}</td>
//                     <td className="nfp-print-nowrap">{derivePercentage(inst.amount, netFeeBase) || 0}%</td>
//                     <td>₹ {formatINR(breakup.sgst)}</td>
//                     <td>₹ {formatINR(breakup.cgst)}</td>
//                     <td>₹ {formatINR(breakup.totalGst)}</td>
//                     <td>₹ {formatINR(breakup.grossAmount)}</td>
//                     <td className="nfp-remarks-cell">{inst.remarks || "-"}</td>
//                   </tr>
//                 );
//               })}
//               <tr className="nfp-print-total-row">
//                 <td colSpan={2}>Total</td>
//                 <td className="nfp-print-nowrap">₹ {formatINR(installmentTotals.instAmount)}</td>
//                 <td></td>
//                 <td>₹ {formatINR(installmentTotals.sgst)}</td>
//                 <td>₹ {formatINR(installmentTotals.cgst)}</td>
//                 <td>₹ {formatINR(installmentTotals.totalGst)}</td>
//                 <td>₹ {formatINR(installmentTotals.grossAmount)}</td>
//                 <td></td>
//               </tr>
//             </tbody>
//           </table>

//           <div className="nfp-print-remarks">
//             <div>
//               <strong>Approved By:</strong> {approvedBy || "-"}
//             </div>
//             <div>
//               <strong>Remarks:</strong> {remarks || "-"}
//             </div>
//           </div>

//           <div className="nfp-print-footer">
//             <div>Generated by: {employeeName || "-"}</div>
//             {showSignature && <div>Parent/Guardian Signature</div>}
//             <div>Printed on: {printDate}</div>
//           </div>
//         </div>
//         </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default EditFeePlan;











import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./newFeePlan.css";
import "./editFeePlan.css";
import "../CreateQuestionsPaper/TestScheduling/testscheduling.css";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import FormDateInput from "../../Components/Shared/FormDateInput/FormDateInput";
import { formatDisplayDate } from "../../Components/Shared/FormDateInput/dateFormat";
import DropDown from "../../Components/Shared/Dropdown/Dropdown";
import EndPoints from "../../Api/EndPoints";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import InfoIcon from "../../Assets/Images/CommanImages/Informative.png";
import MinusImg from "../../Assets/Images/CommanImages/MinusGrey.png";
import YellowPlus from "../../Assets/Images/CommanImages/YellowPlus.png";
import MaleImg from "../../Assets/Images/EployeeRegistration/male_avatar.png";
import FemaleImg from "../../Assets/Images/EployeeRegistration/female_avater.png";

// ---------------------------------------------------------------------------
// Helpers (same conventions as NewFeePlan.jsx)
// ---------------------------------------------------------------------------

const todayStr = () => new Date().toISOString().split("T")[0];

const nextDayStr = (dateStr) => {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + 1);
  return d.toISOString().split("T")[0];
};

const maxDueDateStr = () => {
  const d = new Date();
  d.setFullYear(d.getFullYear() + 5);
  return d.toISOString().split("T")[0];
};

const formatINR = (num) => {
  const n = Number(num);
  if (isNaN(n)) return "0.00";
  return n.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const installmentTaxBreakup = (instAmount, sgstRate, cgstRate) => {
  const base = Number(instAmount) || 0;
  const sgst = (base * (Number(sgstRate) || 0)) / 100;
  const cgst = (base * (Number(cgstRate) || 0)) / 100;
  return { sgst, cgst, totalGst: sgst + cgst, grossAmount: base + sgst + cgst };
};

// Inst Amount is now the directly-editable field; Percentage is derived
// from it (of the pre-tax net fee base) purely for display.
const derivePercentage = (amount, netFeeBase) => {
  const base = Number(netFeeBase) || 0;
  if (base <= 0) return "";
  const pct = (Number(amount) / base) * 100;
  return Number.isFinite(pct) ? pct.toFixed(2) : "";
};

const PAYMENT_MODE_LABELS = {
  1: "Cash",
  2: "Cheque",
  3: "NEFT/IMPS",
  4: "UPI",
  5: "Refund Adjustment",
  6: "Demand Draft",
  7: "Credit Card",
  8: "ECS",
  9: "NACH",
  10: "Online Gateway",
  11: "Bank Deposit",
  12: "Fee Waiver",
};

const emptyInstallmentsRow = () => [
  {
    key: `inst_1_${Date.now()}`,
    fee_schedule_id: null,
    installment_no: 1,
    due_date: "",
    amount: "",
    remarks: "",
  },
];

const SectionHeader = ({ title, isOpen, onToggle }) => (
  <div className="Header-1-C424342 nfp-section-header">
    <span>{title}</span>
    {isOpen ? (
      <img src={MinusImg} alt="Toggle" className="nfp-toggle-icon" onClick={onToggle} />
    ) : (
      <div className="plus nfp-toggle-plus" onClick={onToggle}>
        +
      </div>
    )}
  </div>
);

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

function EditFeePlan({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setNoTimeSet,
  setShowCloseButton,
}) {
  const location = useLocation();
  const navigate = useNavigate();

  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
  const employeeName =
    [
      dataClient?.client_schema_name?.[6]?.[0]?.emp_first_name,
      dataClient?.client_schema_name?.[6]?.[0]?.emp_last_name,
    ]
      .filter(Boolean)
      .join(" ") || userName;
  const instituteName = dataClient?.client_schema_name?.[6]?.[0]?.client_display_name || "";
  const branchName = dataClient?.client_schema_name?.[6]?.[0]?.br_display_name || "";

  const studentId = new URLSearchParams(location.search).get("studentId");

  // ---- Page state ----
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showError, setShowError] = useState(false);

  // ---- Section collapse state ----
  const [sectionOpen, setSectionOpen] = useState({
    student: true,
    fee: true,
    installments: true,
    payments: true,
  });
  const toggleSection = (key) =>
    setSectionOpen((prev) => ({ ...prev, [key]: !prev[key] }));

  // ---- Student profile ----
  const [studentProfile, setStudentProfile] = useState(null);
  const [studentPhotoUrl, setStudentPhotoUrl] = useState(null);

  // ---- Sessions + all of the student's fee plans across sessions ----
  const [sessionsList, setSessionsList] = useState([]);
  const [allPlans, setAllPlans] = useState([]); // every fee plan this student has, any session
  const [selectedSessionId, setSelectedSessionId] = useState(null);

  // ---- Fee plan identity ----
  const [feePlanId, setFeePlanId] = useState(null);
  const [accStudentId, setAccStudentId] = useState(null); // carried through as-is, not editable here
  const [registrationFormNo, setRegistrationFormNo] = useState("");
  const [pristineSnapshot, setPristineSnapshot] = useState(null);

  // ---- Fee breakdown ----
  const [totalFee, setTotalFee] = useState("");
  const [scholarship, setScholarship] = useState("");
  const [discount, setDiscount] = useState("");
  const [defaultSgst, setDefaultSgst] = useState("9");
  const [defaultCgst, setDefaultCgst] = useState("9");

  // ---- Batch Type (editable - prefilled from the student's enquiry,
  // but course_fees is now split by batch type, so changing it needs
  // to re-fetch the applicable fees) ----
  const [batchTypes, setBatchTypes] = useState([]);
  const [selectedBatchType, setSelectedBatchType] = useState(null);

  // ---- Installments ----
  const [installments, setInstallments] = useState([]);

  // ---- Additional ----
  const [approvedBy, setApprovedBy] = useState("");
  const [remarks, setRemarks] = useState("");

  // ---- Payment history ----
  // Full history for the student (every session/plan) - filtered down to
  // the selected session's plan for both display and paid-installment
  // locking, using fee_schedule_id to trace each payment back. Compared
  // as strings since the two APIs backing this (get-student-fee-plan and
  // get-student-fee-payment-history) aren't guaranteed to serialize the
  // same numeric id as the same JS type (Set/strict-equality otherwise
  // silently never matches - same class of bug as the session dropdown).
  const [fullPaymentHistory, setFullPaymentHistory] = useState([]);

  const paymentHistory = React.useMemo(() => {
    const idsForThisPlan = new Set(
      installments
        .map((i) => (i.fee_schedule_id != null ? String(i.fee_schedule_id) : null))
        .filter(Boolean)
    );
    return fullPaymentHistory.filter(
      (p) => p.fee_schedule_id != null && idsForThisPlan.has(String(p.fee_schedule_id))
    );
  }, [fullPaymentHistory, installments]);

  const paidFeeScheduleIds = React.useMemo(
    () =>
      new Set(
        fullPaymentHistory
          .map((p) => (p.fee_schedule_id != null ? String(p.fee_schedule_id) : null))
          .filter(Boolean)
      ),
    [fullPaymentHistory]
  );

  const isCurrentSession = selectedSessionId != null &&
    studentProfile?.session_id != null &&
    Number(selectedSessionId) === Number(studentProfile.session_id);

  const selectedSession = sessionsList.find(
    (s) => Number(s.session_id) === Number(selectedSessionId)
  );
  const sessionStartDate = selectedSession?.session_start_date
    ? selectedSession.session_start_date.split(" ")[0]
    : "";
  const sessionEndDate = selectedSession?.session_end_date
    ? selectedSession.session_end_date.split(" ")[0]
    : "";

  // A scholarship or concession needs a paper trail - Approved By and
  // Remarks both become mandatory whenever either one is applied.
  const isConcessionApplied = Number(scholarship) > 0 || Number(discount) > 0;

  const netFeeBase = Math.max(
    0,
    (Number(totalFee) || 0) - (Number(scholarship) || 0) - (Number(discount) || 0)
  );
  const sgstAmount = (netFeeBase * (Number(defaultSgst) || 0)) / 100;
  const cgstAmount = (netFeeBase * (Number(defaultCgst) || 0)) / 100;
  const totalGstAmount = sgstAmount + cgstAmount;
  const netFee = netFeeBase + totalGstAmount;

  const totalAlreadyPaid = paymentHistory.reduce(
    (sum, p) => sum + (Number(p.amount) || 0) + (Number(p.sgst) || 0) + (Number(p.cgst) || 0),
    0
  );

  const installmentTotals = installments.reduce(
    (acc, inst) => {
      const instAmount = Number(inst.amount) || 0;
      const { sgst, cgst, totalGst, grossAmount } = installmentTaxBreakup(
        instAmount,
        defaultSgst,
        defaultCgst
      );
      acc.instAmount += instAmount;
      acc.sgst += sgst;
      acc.cgst += cgst;
      acc.totalGst += totalGst;
      acc.grossAmount += grossAmount;
      return acc;
    },
    { instAmount: 0, sgst: 0, cgst: 0, totalGst: 0, grossAmount: 0 }
  );

  const notify = (message, isError = true) => {
    setShowCloseButton(false);
    if (isError) setNoTimeSet && setNoTimeSet(false);
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX" style={{ width: "100%" }}>
        <div className="messagebox-insider1" style={{ width: "100%" }}>
          <span>{message}</span>
        </div>
      </div>
    );
    setActiveImg(isError ? ErrorImg : InfoIcon);
  };

  // Same shared message box used for errors/warnings/save messages -
  // shown while the page's initial data is loading.
  const showLoading = (text) => {
    setNoTimeSet && setNoTimeSet(true);
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span style={{ marginLeft: "10px", marginTop: "3px" }}>{text}</span>
        </div>
      </div>
    );
    setActiveImg(false);
  };

  // ---------------------------------------------------------------------
  // Populate the fee/installments sections from a given plan - or clear
  // them to blank if this session has no plan on record yet.
  // ---------------------------------------------------------------------
  const applyPlanForSession = (sessionId, plansList) => {
    const plan = plansList
      .filter((p) => Number(p.session_id) === Number(sessionId))
      .sort((a, b) => b.fee_plan_id - a.fee_plan_id)[0];

    if (!plan) {
      setFeePlanId(null);
      setAccStudentId(null);
      setRegistrationFormNo("");
      setTotalFee("");
      setScholarship("");
      setDiscount("");
      setDefaultSgst("9");
      setDefaultCgst("9");
      setApprovedBy("");
      setRemarks("");
      setInstallments(emptyInstallmentsRow());
      setPristineSnapshot(
        JSON.stringify({
          accStudentId: "",
          registrationFormNo: "",
          totalFee: "",
          scholarship: "",
          discount: "",
          approvedBy: "",
          remarks: "",
          installments: [{ due_date: "", amount: "", remarks: "" }],
        })
      );
      return;
    }

    const planNetFeeBase = Math.max(
      0,
      (Number(plan.total_fee_inr) || 0) -
        (Number(plan.scholarship_amount) || 0) -
        (Number(plan.discount_amount) || 0)
    );

    if (plan.sgst == null || plan.cgst == null) {
      notify(
        "This fee plan is missing its SGST/CGST rate from the server - can't load it safely. Please check the plan's data before continuing."
      );
      return;
    }

    setFeePlanId(plan.fee_plan_id);
    setAccStudentId(plan.acc_student_id ?? null);
    setRegistrationFormNo(plan.reg_form_no ?? "");
    setTotalFee(plan.total_fee_inr ?? "");
    setScholarship(plan.scholarship_amount ?? "");
    setDiscount(plan.discount_amount ?? "");
    setDefaultSgst(derivePercentage(plan.sgst, planNetFeeBase));
    setDefaultCgst(derivePercentage(plan.cgst, planNetFeeBase));
    setApprovedBy(plan.approved_by || "");
    setRemarks(plan.remarks || "");

    const loadedInstallments = (plan.fee_schedule_list || [])
      .slice()
      .sort((a, b) => a.installment_no - b.installment_no)
      .map((sched) => ({
        key: `inst_${sched.installment_no}_${Date.now()}_${Math.random()
          .toString(36)
          .slice(2, 6)}`,
        fee_schedule_id: sched.fee_schedule_id ?? null,
        installment_no: sched.installment_no,
        due_date: sched.due_date || "",
        amount: sched.amount != null ? String(sched.amount) : "",
        remarks: sched.remarks || "",
      }));

    setInstallments(loadedInstallments.length ? loadedInstallments : emptyInstallmentsRow());

    setPristineSnapshot(
      JSON.stringify({
        accStudentId: plan.acc_student_id ?? "",
        registrationFormNo: plan.reg_form_no ?? "",
        totalFee: String(plan.total_fee_inr ?? ""),
        scholarship: String(plan.scholarship_amount ?? ""),
        discount: String(plan.discount_amount ?? ""),
        approvedBy: plan.approved_by || "",
        remarks: plan.remarks || "",
        installments: (loadedInstallments.length
          ? loadedInstallments
          : [{ due_date: "", amount: "", remarks: "" }]
        ).map((i) => ({
          due_date: i.due_date,
          amount: String(i.amount ?? ""),
          remarks: i.remarks || "",
        })),
      })
    );
  };

  const handleSessionChange = (sessionId) => {
    setSelectedSessionId(sessionId);
    setIsEditing(false);
    setShowError(false);
    applyPlanForSession(sessionId, allPlans);
  };

  // ---------------------------------------------------------------------
  // Load: student profile + sessions + all fee plans + payment history
  // ---------------------------------------------------------------------
  const loadData = async () => {
    if (!studentId) {
      setLoadError("No student was specified. Go back and select a student to edit.");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setLoadError("");
    setIsEditing(false);
    setShowError(false);
    showLoading("Loading data, please wait...");

    try {
      const token = localStorage.getItem("other");
      const [profileRes, planRes, sessionsRes] = await Promise.all([
        fetch(`${EndPoints.GET_STUDENT_ADMISSION_PROFILE}?student_id=${studentId}`, {
          headers: { accept: "application/json", Authorization: `Bearer ${token}` },
        }).then((r) => r.json()),
        fetch(`${EndPoints.GET_STUDENT_FEE_PLAN}?student_id=${studentId}`, {
          headers: { accept: "application/json", Authorization: `Bearer ${token}` },
        }).then((r) => r.json()),
        fetch(EndPoints.GET_SESSIONS_LIST, {
          headers: { accept: "application/json" },
        }).then((r) => r.json()),
      ]);

      const profile = profileRes?.data?.[0];
      if (profileRes?.status === 200 && profile) {
        setStudentProfile(profile);
        if (profile.class_id != null && profile.course_id != null) {
          fetchBatchTypes(profile.class_id, profile.course_id);
        }
        setSelectedBatchType(profile.batch_type_id ?? null);
        if (profileRes?.signed_url && profileRes.signed_url !== "URL not found") {
          setStudentPhotoUrl(profileRes.signed_url);
        }
      } else {
        setStudentProfile(null);
      }

      const sessions = Array.isArray(sessionsRes?.data)
        ? sessionsRes.data
        : Array.isArray(sessionsRes)
        ? sessionsRes
        : [];
      setSessionsList(sessions);

      const plans = Array.isArray(planRes?.data) ? planRes.data : [];
      setAllPlans(plans);

      // Default to the student's current session - falls back to
      // whichever plan is most recent if the current session can't be
      // determined for some reason.
      const defaultSessionId =
        profile?.session_id ??
        (plans.length
          ? [...plans].sort((a, b) => b.fee_plan_id - a.fee_plan_id)[0].session_id
          : null);

      setSelectedSessionId(defaultSessionId);

      if (defaultSessionId != null) {
        applyPlanForSession(defaultSessionId, plans);
      } else if (!plans.length) {
        setLoadError(
          "No fee plan exists for this student yet, and no session could be determined. You can create one instead."
        );
      }

      // Payment history is supplementary/read-only - don't block the page
      // Fetched once for the whole student; filtered down to the
      // selected session's plan for display via fee_schedule_id. A
      // failure here shouldn't block the rest of the page loading, so
      // it just falls back to an empty history rather than surfacing
      // an error on it if it fails.
      try {
        const historyRes = await fetch(
          `${EndPoints.GET_STUDENT_FEE_PAYMENT_HISTORY}?student_id=${studentId}`,
          { headers: { accept: "application/json", Authorization: `Bearer ${token}` } }
        ).then((r) => r.json());
        setFullPaymentHistory(Array.isArray(historyRes?.data) ? historyRes.data : []);
      } catch (err) {
        console.error("Error fetching payment history:", err);
        setFullPaymentHistory([]);
      }

      setIsLoading(false);
      setIsMessageBoxVisible(false);
    } catch (err) {
      console.error("Error loading fee plan:", err);
      setLoadError("Something went wrong while loading this fee plan. Please try again.");
      setIsLoading(false);
      setIsMessageBoxVisible(false);
    }
  };

  // Batch Type options are scoped to the student's (class, course).
  const fetchBatchTypes = async (classId, courseId) => {
    if (classId == null || courseId == null) {
      setBatchTypes([]);
      return;
    }
    try {
      const res = await fetch(
        `${EndPoints.GET_BATCH_TYPES}?class_id=${classId}&course_id=${courseId}`,
        { headers: { accept: "application/json" } }
      );
      const data = await res.json();
      setBatchTypes(Array.isArray(data?.data) ? data.data : []);
    } catch (err) {
      console.error("Error fetching batch types:", err);
      setBatchTypes([]);
    }
  };

  // Batch Type changed on the form - re-fetch course fees for the newly
  // selected batch type and overwrite the fee fields with them, rather
  // than leaving whatever the existing plan (or the previous batch
  // type) had.
  const handleBatchTypeChange = async (batchTypeId) => {
    setSelectedBatchType(batchTypeId);
    if (!studentId) return;
    try {
      const token = localStorage.getItem("other");
      const feesResponse = await fetch(
        `${EndPoints.GET_COURSE_FEES_FOR_STUDENT}?student_id=${studentId}&batch_type=${batchTypeId}`,
        { headers: { accept: "application/json", Authorization: `Bearer ${token}` } }
      );
      const feesData = await feesResponse.json();
      if (feesData?.status === 200 && feesData?.data) {
        setDefaultSgst(feesData.data.sgst_prcnt);
        setDefaultCgst(feesData.data.cgst_prcnt);
        setTotalFee(feesData.data.base_fees);
      } else {
        notify(
          "No SGST/CGST rate is configured for this course/session/branch/class/batch type combination - please contact your administrator to configure this."
        );
      }
    } catch (err) {
      console.error("Error fetching course fees:", err);
      notify(
        "No SGST/CGST rate is configured for this course/session/branch/class/batch type combination - please contact your administrator to configure this."
      );
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentId]);

  // ---------------------------------------------------------------------
  // Installments
  // ---------------------------------------------------------------------
  const handleAddInstallment = () => {
    if (installments.length >= 12) {
      notify("A fee plan can have at most 12 installments.");
      return;
    }
    setInstallments((prev) => {
      const nextNo = prev.length
        ? Math.max(...prev.map((i) => i.installment_no)) + 1
        : 1;
      return [
        ...prev,
        {
          key: `inst_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
          fee_schedule_id: null,
          installment_no: nextNo,
          due_date: "",
          amount: "",
          remarks: "",
        },
      ];
    });
  };

  // The add-installment button only shows while the last row is being
  // written in - tracked via focus bubbling up from its fields (React's
  // onFocus/onBlur bubble even though FormInputs doesn't forward these
  // as props). Blur hides it after a short delay rather than
  // immediately, so a click on the button itself (which briefly blurs
  // the field first) still has time to register before it disappears.
  const [isLastRowActive, setIsLastRowActive] = useState(false);
  const lastRowBlurTimeoutRef = useRef(null);
  const handleLastRowFocus = () => {
    if (lastRowBlurTimeoutRef.current) clearTimeout(lastRowBlurTimeoutRef.current);
    setIsLastRowActive(true);
  };
  const handleLastRowBlur = () => {
    lastRowBlurTimeoutRef.current = setTimeout(() => setIsLastRowActive(false), 200);
  };

  const handleRemoveInstallment = (key) => {
    // Renumbering here used to reassign installment_no for every
    // remaining row sequentially - which could shift a *paid*
    // installment's number if an unpaid one before it was removed. The
    // backend's paid-installment protection matches by installment_no,
    // so that shift made it look like the paid installment itself had
    // been removed, incorrectly blocking the save. Numbers are left as
    // they are now - a gap in the sequence is a minor cosmetic
    // tradeoff for not silently corrupting a paid installment's
    // identity.
    setInstallments((prev) => prev.filter((inst) => inst.key !== key));
  };

  const handleInstallmentField = (key, field, value) => {
    setInstallments((prev) =>
      prev.map((inst) => (inst.key === key ? { ...inst, [field]: value } : inst))
    );
  };

  // ---------------------------------------------------------------------
  // Edit / Cancel / Print
  // ---------------------------------------------------------------------
  const handleEdit = () => setIsEditing(true);

  // True once the person has actually changed something from what was
  // loaded - used to decide whether Cancel needs to confirm at all.
  const isFormDirty = () => {
    if (pristineSnapshot === null) return false;
    const currentSnapshot = JSON.stringify({
      accStudentId: accStudentId || "",
      registrationFormNo: registrationFormNo || "",
      totalFee: String(totalFee ?? ""),
      scholarship: String(scholarship ?? ""),
      discount: String(discount ?? ""),
      approvedBy: approvedBy || "",
      remarks: remarks || "",
      installments: installments.map((i) => ({
        due_date: i.due_date,
        amount: String(i.amount ?? ""),
        remarks: i.remarks || "",
      })),
    });
    return currentSnapshot !== pristineSnapshot;
  };

  const handleCancel = () => {
    if (!isFormDirty()) {
      navigate("/fee_plan_dashboard");
      return;
    }

    setShowCloseButton(false);
    setNoTimeSet(true); // keep the box open (it normally auto-closes after 3.5s) until Yes/No is clicked
    setIsMessageBoxVisible(true);
    setActiveImg(ErrorImg);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <span>Are you sure you want to cancel? Unsaved changes will be lost.</span>
        </div>
        <div className="messagebox-insider2" style={{ display: "flex", gap: "10px" }}>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              setNoTimeSet(false);
              navigate("/fee_plan_dashboard");
            }}
          >
            Yes
          </button>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              setNoTimeSet(false);
            }}
          >
            No
          </button>
        </div>
      </div>
    );
  };

  const handlePrint = () => {
    const originalTitle = document.title;
    // Browsers use document.title both as the default "Save as PDF"
    // filename AND as the print header text at the top of the page -
    // there's no way to set one without the other from the page, so a
    // meaningful save filename necessarily means this text also shows
    // at the top when printed.
    const studentName = studentProfile?.student_full_name || "Student";
    const rollNo = studentProfile?.Roll_Number || "";
    document.title = `${(studentName + rollNo).replace(/[,\s]/g, "")}_feeplan`;
    window.print();
    document.title = originalTitle;
  };

  // ---------------------------------------------------------------------
  // Save (create-student-fee-plan when this session has no plan yet,
  // update-student-fee-plan otherwise)
  // ---------------------------------------------------------------------
  const handleSave = async () => {
    setShowError(true);

    if (!studentId || selectedSessionId == null) {
      notify("Missing student/session reference. Please reload the page and try again.");
      return;
    }
    if (!studentProfile?.course_id) {
      notify("Course details are unavailable for this student.");
      return;
    }
    if (!totalFee || Number(totalFee) <= 0) {
      notify("Please enter a valid Total Base Fee.");
      return;
    }
    if (installments.length === 0) {
      notify("Please add at least one installment.");
      return;
    }
    for (const inst of installments) {
      if (!inst.due_date || !inst.amount || Number(inst.amount) <= 0) {
        notify("Please complete the due date and amount for every installment.");
        return;
      }
      if (Number(derivePercentage(inst.amount, netFeeBase)) > 100) {
        notify(`Installment ${inst.installment_no}'s amount can't be more than the net fee (100%).`);
        return;
      }
      if (inst.due_date < todayStr()) {
        notify(
          `Installment ${inst.installment_no}'s due date can't be in the past - it must be today or later.`
        );
        return;
      }
      if (sessionEndDate && inst.due_date > sessionEndDate) {
        notify(
          `Installment ${inst.installment_no}'s due date can't be after the session's end date (${formatDisplayDate(sessionEndDate)}).`
        );
        return;
      }
    }
    for (let i = 1; i < installments.length; i++) {
      if (installments[i].due_date <= installments[i - 1].due_date) {
        notify(
          `Installment ${installments[i].installment_no}'s due date must be later than installment ${installments[i - 1].installment_no}'s due date.`
        );
        return;
      }
    }
    if (Math.abs(installmentTotals.instAmount - netFeeBase) > 1) {
      notify(
        `Installment amounts (₹ ${formatINR(
          installmentTotals.instAmount
        )}) do not add up to the Net Fee (₹ ${formatINR(
          netFeeBase
        )}). Please adjust the installment amount to match net fee.`
      );
      return;
    }
    if (isConcessionApplied) {
      const missing = [];
      if (!approvedBy.trim()) missing.push("Approved By");
      if (!remarks.trim()) missing.push("Remarks");
      if (missing.length > 0) {
        notify(
          `${missing.join(" and ")} ${
            missing.length > 1 ? "are" : "is"
          } required when a scholarship or concession is applied.`
        );
        return;
      }
    }
    if (totalAlreadyPaid > netFee) {
      notify(
        `Total amount already paid against this plan (₹ ${formatINR(
          totalAlreadyPaid
        )}) exceeds the new Net Fee (₹ ${formatINR(
          netFee
        )}). Net Fee can't be reduced below what has already been collected.`
      );
      return;
    }
    if (!userName) {
      notify("Unable to determine the logged-in user. Please re-login and try again.");
      return;
    }

    const isCreatingNewPlan = !feePlanId;

    const fee_schedule_list = installments.map((inst) => {
      const instAmount = Number(inst.amount) || 0;
      const breakup = installmentTaxBreakup(instAmount, defaultSgst, defaultCgst);
      return {
        installment_no: inst.installment_no,
        due_date: inst.due_date,
        amount: Number(instAmount),
        sgst: breakup.sgst,
        cgst: breakup.cgst,
        remarks: inst.remarks || null,
      };
    });

    const payload = isCreatingNewPlan
      ? {
          student_id: Number(studentId),
          session_id: Number(selectedSessionId),
          course_id: Number(studentProfile.course_id),
          reg_form_no: registrationFormNo || null,
          total_fee_inr: Number(totalFee),
          scholarship_amount: Number(scholarship) || 0,
          discount_amount: Number(discount) || 0,
          net_fee: Number(netFee),
          sgst: sgstAmount,
          cgst: cgstAmount,
          remarks: remarks || null,
          approved_by: approvedBy || null,
          username: userName,
          fee_schedule_list,
        }
      : {
          fee_plan_id: Number(feePlanId),
          student_id: Number(studentId),
          session_id: Number(selectedSessionId),
          course_id: Number(studentProfile.course_id),
          acc_student_id: accStudentId ?? null,
          reg_form_no: registrationFormNo || null,
          total_fee_inr: Number(totalFee),
          scholarship_amount: Number(scholarship) || 0,
          discount_amount: Number(discount) || 0,
          net_fee: Number(netFee),
          sgst: sgstAmount,
          cgst: cgstAmount,
          remarks: remarks || null,
          approved_by: approvedBy || null,
          username: userName,
          fee_schedule_list,
        };

    setIsSubmitting(true);
    try {
      const token = localStorage.getItem("other");
      const response = await fetch(
        isCreatingNewPlan ? EndPoints.CREATE_STUDENT_FEE_PLAN : EndPoints.UPDATE_STUDENT_FEE_PLAN,
        {
          method: isCreatingNewPlan ? "POST" : "PUT",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();

      if (data?.status === 200) {
        notify(data.message || "Fee plan saved successfully.", false);
        setIsEditing(false);
        setShowError(false);
        loadData();
      } else {
        notify(data?.message || "Failed to save the fee plan.");
      }
    } catch (err) {
      console.error("Error saving fee plan:", err);
      notify("An error occurred while saving the fee plan.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const printDate = formatDisplayDate(new Date());
  // Locked whenever not actively editing, OR the selected session isn't
  // the student's current one - past/future sessions are view-only, no
  // way to enter edit mode for them at all (see the Edit button below).
  const locked = !isEditing || !isCurrentSession;

  // Only one batch type available for this class/course - nothing to
  // actually choose, so select it automatically instead of leaving the
  // dropdown sitting unselected and locked. Skipped while the plan itself
  // isn't editable (`locked`), so this never overwrites fee fields on a
  // read-only/past-session view.
  useEffect(() => {
    if (!locked && batchTypes.length === 1) {
      handleBatchTypeChange(batchTypes[0].batch_type_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchTypes, locked]);

  // ---------------------------------------------------------------------
  // Loading / error states
  // ---------------------------------------------------------------------
  if (isLoading) {
    return (
      <div className="nfp-container">
        <div className="efp-state-wrap">
          <div className="efp-state-title">Loading fee plan…</div>
        </div>
      </div>
    );
  }

  if (loadError && allPlans.length === 0) {
    return (
      <div className="nfp-container">
        <div className="efp-state-wrap">
          <div className="efp-state-title">{loadError}</div>
          <button
            className="create-test-section-btn"
            onClick={() => navigate("/new_fee_plan")}
          >
            CREATE NEW FEE PLAN
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="nfp-container">
      <div className="nfp-page">
        <div className="nfp-page-header">
          <div className="nfp-page-title">Fee Plan</div>
          <div className="nfp-header-btns">
            <button
              className="create-test-section-btn"
              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              onClick={handlePrint}
            >
              PRINT
            </button>
            <button
              className="create-test-section-btn"
              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              onClick={handleCancel}
              disabled={isSubmitting}
            >
              CANCEL
            </button>
            {isEditing ? (
              <button
                className="create-test-section-btn"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                onClick={handleSave}
                disabled={isSubmitting}
              >
                {isSubmitting ? "SAVING..." : "SAVE"}
              </button>
            ) : (
              isCurrentSession && (
                <button
                  className="create-test-section-btn"
                  style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                  onClick={handleEdit}
                >
                  EDIT
                </button>
              )
            )}
          </div>
        </div>

        {/* ---------------- Student & Course Details ---------------- */}
        <div className="nfp-section">
          <SectionHeader
            title="STUDENT & COURSE DETAILS"
            isOpen={sectionOpen.student}
            onToggle={() => toggleSection("student")}
          />
          {sectionOpen.student && (
            <div className="Body-1-C424342 nfp-section-body">
              {studentProfile ? (
                <>
                  <div className="nfp-grid-3">
                    <FormInputs
                      label="Student"
                      disabled
                      value={studentProfile?.student_full_name || ""}
                    />
                    <FormInputs
                      label="Roll No"
                      disabled
                      value={studentProfile?.Roll_Number || ""}
                    />
                    <FormInputs label="Batch" disabled value={studentProfile?.Batch || ""} />
                  </div>

                  <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
                    <div className="formInput">
                      <label>
                        Batch Type
                        <span>*</span>
                      </label>
                      <DropDown
                        selected={selectedBatchType}
                        setSelected={handleBatchTypeChange}
                        options={batchTypes.map((bt) => ({
                          id: bt.batch_type_id,
                          label: bt.batch_type_desc,
                        }))}
                        placeholder={batchTypes.length === 0 ? "No batch types for this class" : "Select batch type"}
                        disabled={locked || batchTypes.length <= 1}
                        Height="auto"
                        minheight="150px"
                        OverFlow="auto"
                      />
                    </div>
                    <FormInputs
                      label="Class"
                      disabled
                      value={studentProfile?.Class_name || ""}
                    />
                    <FormInputs
                      label="Course"
                      disabled
                      value={studentProfile?.Course_Name || ""}
                    />
                  </div>

                  <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
                    <FormInputs
                      label="Father/Mother/Guardian"
                      disabled
                      value={
                        studentProfile?.father_name ||
                        studentProfile?.mother_name ||
                        studentProfile?.guardian_name ||
                        ""
                      }
                    />
                    <div className="formInput">
                      <label>Session</label>
                      <DropDown
                        selected={selectedSessionId}
                        setSelected={handleSessionChange}
                        options={sessionsList.map((s) => ({
                          id: s.session_id,
                          label: s.session_name,
                        }))}
                        Height="auto"
                        minheight="150px"
                        OverFlow="auto"
                      />
                    </div>
                    <FormInputs
                      label="Enquiry Date"
                      disabled
                      value={formatDisplayDate(studentProfile?.admission_date)}
                    />
                  </div>

                  <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
                    <FormInputs
                      label="Account Student ID"
                      disabled={locked}
                      placeholder="Enter Ledger / Account ID"
                      value={accStudentId || ""}
                      maxLength={10}
                      onChange={(e) => setAccStudentId(e.target.value.replace(/\D/g, ""))}
                    />
                  </div>
                </>
              ) : (
                <div className="efp-state-message">Student details unavailable.</div>
              )}
            </div>
          )}
        </div>

        {/* ---------------- Fee Details ---------------- */}
        <div className="nfp-section">
          <SectionHeader
            title="FEE DETAILS"
            isOpen={sectionOpen.fee}
            onToggle={() => toggleSection("fee")}
          />
          {sectionOpen.fee && (
            <div className="Body-1-C424342 nfp-section-body">
              <div className="nfp-grid-3">
                <FormInputs
                  label="Total Base Fee (₹)"
                  required
                  showError={showError}
                  disabled
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                  value={totalFee}
                />
                <FormInputs
                  label="Scholarship (₹)"
                  disabled={locked}
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                  value={scholarship}
                  onChange={(e) => setScholarship(e.target.value)}
                />
                <FormInputs
                  label="Concession (₹)"
                  disabled={locked}
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                  value={discount}
                  onChange={(e) => setDiscount(e.target.value)}
                />
              </div>

              <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
                <FormInputs label="Net Fee (₹)" value={`${formatINR(netFeeBase)}`} disabled />
                <FormInputs label="SGST (₹)" value={`${formatINR(sgstAmount)}`} disabled />
                <FormInputs label="CGST (₹)" value={`${formatINR(cgstAmount)}`} disabled />
              </div>

              <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
                <FormInputs
                  label="Total Fees Payable (₹)"
                  value={`${formatINR(netFee)}`}
                  disabled
                />
                <FormInputs
                  label="Approved By"
                  disabled={locked}
                  placeholder="Name of approving authority"
                  value={approvedBy}
                  maxLength={10}
                  onChange={(e) => setApprovedBy(e.target.value)}
                  required={isConcessionApplied}
                  showError={showError}
                />
                <FormInputs
                  label="Remarks"
                  disabled={locked}
                  placeholder="Add any notes regarding this fee plan..."
                  value={remarks}
                  maxLength={500}
                  onChange={(e) => setRemarks(e.target.value)}
                  required={isConcessionApplied}
                  showError={showError}
                />
              </div>

              <div className="nfp-grid-3" style={{ marginTop: "10px" }}>
                <FormInputs
                  label="Registration Form No."
                  disabled={locked}
                  placeholder="Enter registration form number"
                  value={registrationFormNo}
                  maxLength={10}
                  onChange={(e) => setRegistrationFormNo(e.target.value)}
                />
              </div>
            </div>
          )}
        </div>

        {/* ---------------- Installment Schedule ---------------- */}
        <div className="nfp-section">
          <div className="Header-1-C424342 nfp-section-header">
            <span>INSTALLMENT SCHEDULE</span>
            {sectionOpen.installments ? (
              <img
                src={MinusImg}
                alt="Toggle"
                className="nfp-toggle-icon"
                onClick={() => toggleSection("installments")}
              />
            ) : (
              <div
                className="plus nfp-toggle-plus"
                onClick={() => toggleSection("installments")}
              >
                +
              </div>
            )}
          </div>

          {sectionOpen.installments && (
            <div className="Body-1-C424342 nfp-section-body nfp-section-body-flush">
              <div className="nfp-table-wrap">
                <table className="nfp-table">
                  <thead>
                    <tr>
                      {isEditing && <th style={{ width: "48px" }}></th>}
                      <th style={{ width: "60px" }}>Inst. No</th>
                      <th>Due Date</th>
                      <th>Inst Amount (₹)</th>
                      <th>Percentage (%)</th>
                      <th>SGST (₹)</th>
                      <th>CGST (₹)</th>
                      <th>Total GST (₹)</th>
                      <th>Gross Inst Amount (₹)</th>
                      <th>Remarks</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {installments.map((inst, idx) => {
                      const instAmount = Number(inst.amount) || 0;
                      const breakup = installmentTaxBreakup(
                        instAmount,
                        defaultSgst,
                        defaultCgst
                      );
                      // Already has a payment recorded against it - can't be
                      // changed or removed, even while otherwise editing.
                      const isPaid =
                        inst.fee_schedule_id &&
                        paidFeeScheduleIds.has(String(inst.fee_schedule_id));
                      const rowLocked = locked || isPaid;
                      const isLastRow = idx === installments.length - 1;
                      const previousDueDate = idx > 0 ? installments[idx - 1].due_date : null;
                      const minDueDate =
                        previousDueDate && nextDayStr(previousDueDate) > todayStr()
                          ? nextDayStr(previousDueDate)
                          : todayStr();
                      return (
                        <tr
                          key={inst.key}
                          onFocus={isLastRow ? handleLastRowFocus : undefined}
                          onBlur={isLastRow ? handleLastRowBlur : undefined}
                        >
                          {isEditing && (
                            <td className="nfp-row-remove">
                              <div className="nfp-row-remove-spacer"></div>
                              {installments.length > 1 && !isPaid && (
                                <span
                                  className="nfp-remove-btn"
                                  onClick={() => handleRemoveInstallment(inst.key)}
                                  title="Remove installment"
                                >
                                  ×
                                </span>
                              )}
                            </td>
                          )}
                          <td className="nfp-inst-no">{inst.installment_no}</td>
                          <td>
                            <FormDateInput
                              label=""
                              required
                              showError={showError}
                              disabled={rowLocked}
                              min={minDueDate}
                              max={sessionEndDate || maxDueDateStr()}
                              value={inst.due_date}
                              onChange={(e) =>
                                handleInstallmentField(inst.key, "due_date", e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <FormInputs
                              label=""
                              type="number"
                              required
                              showError={showError}
                              disabled={rowLocked}
                              min="0"
                              step="0.01"
                              placeholder="0"
                              value={inst.amount}
                              onChange={(e) =>
                                handleInstallmentField(inst.key, "amount", e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <FormInputs
                              label=""
                              value={`${derivePercentage(inst.amount, netFeeBase)}`}
                              disabled
                            />
                          </td>
                          <td>
                            <FormInputs label="" value={`${formatINR(breakup.sgst)}`} disabled />
                          </td>
                          <td>
                            <FormInputs label="" value={`${formatINR(breakup.cgst)}`} disabled />
                          </td>
                          <td>
                            <FormInputs
                              label=""
                              value={`${formatINR(breakup.totalGst)}`}
                              disabled
                            />
                          </td>
                          <td>
                            <FormInputs
                              label=""
                              value={`${formatINR(breakup.grossAmount)}`}
                              disabled
                            />
                          </td>
                          <td>
                            <FormInputs
                              label=""
                              placeholder="Optional"
                              disabled={rowLocked}
                              value={inst.remarks}
                              className="nfp-remarks-input"
                              onChange={(e) =>
                                handleInstallmentField(inst.key, "remarks", e.target.value)
                              }
                            />
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {isPaid ? (
                              <span className="efp-paid-badge" title="Already paid - locked">
                                Paid
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                      );
                    })}
                    {isEditing && !locked && isLastRowActive && (
                      <tr className="nfp-add-installment-row-inline">
                        <td colSpan={10}></td>
                        <td style={{ textAlign: "right" }}>
                          <img
                            src={YellowPlus}
                            alt="Add installment"
                            className="nfp-add-icon"
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={handleAddInstallment}
                            title="Add installment"
                          />
                        </td>
                      </tr>
                    )}
                    <tr className="nfp-total-row">
                      {isEditing && <td></td>}
                      <td colSpan={2}>Total</td>
                      <td>₹ {formatINR(installmentTotals.instAmount)}</td>
                      <td></td>
                      <td>₹ {formatINR(installmentTotals.sgst)}</td>
                      <td>₹ {formatINR(installmentTotals.cgst)}</td>
                      <td>₹ {formatINR(installmentTotals.totalGst)}</td>
                      <td>₹ {formatINR(installmentTotals.grossAmount)}</td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="nfp-installment-total-row">
                <span>Net Fee Payable: ₹ {formatINR(netFee)}</span>
              </div>
            </div>
          )}
        </div>

        {/* ---------------- Payment History (read-only) ---------------- */}
        <div className="nfp-section">
          <SectionHeader
            title="PAYMENT HISTORY"
            isOpen={sectionOpen.payments}
            onToggle={() => toggleSection("payments")}
          />
          {sectionOpen.payments && (
            <div className="Body-1-C424342 nfp-section-body nfp-section-body-flush">
              {paymentHistory.length === 0 ? (
                <div className="efp-payment-empty">
                  No payments recorded yet for this session's plan.
                </div>
              ) : (
                <div className="nfp-table-wrap">
                  <table className="nfp-table">
                    <thead>
                      <tr>
                        <th>Payment Date</th>
                        <th>Amount (₹)</th>
                        <th>SGST (₹)</th>
                        <th>CGST (₹)</th>
                        <th>Due Amount (₹)</th>
                        <th>Mode</th>
                        <th>Transaction No</th>
                        <th>Bank Name</th>
                        <th>Received By</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paymentHistory.map((p, idx) => (
                        <tr key={idx}>
                          <td>{p.payment_date || "-"}</td>
                          <td>₹ {formatINR(p.amount)}</td>
                          <td>₹ {formatINR(p.sgst)}</td>
                          <td>₹ {formatINR(p.cgst)}</td>
                          <td>₹ {formatINR(p.due_amt)}</td>
                          <td>{PAYMENT_MODE_LABELS[p.payment_mode_id] || "-"}</td>
                          <td>{p.transaction_no || "-"}</td>
                          <td>{p.bank_name || "-"}</td>
                          <td>{p.received_by_name || p.received_by || "-"}</td>
                          <td className="nfp-remarks-cell">{p.remarks || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* ---------------- Print-only fee statement (hidden on screen) ---------------- */}
      {/* Two copies on one A4 portrait page - the first includes a
          Parent/Guardian Signature line in the footer, the second
          doesn't, per request. */}
      <div className="nfp-print-only">
        {[true, false].map((showSignature, copyIdx) => (
        <div className="nfp-print-copy" key={copyIdx}>
        <div className="nfp-print-box">
          <div className="nfp-print-header">
            <div className="nfp-print-header-side"></div>
            <div className="nfp-print-header-center">
              <div className="nfp-print-institute">{instituteName || "Fee Statement"}</div>
              {branchName && <div className="nfp-print-branch">{branchName}</div>}
              <div className="nfp-print-title">Statement for Fee</div>
            </div>
            <div className="nfp-print-header-side"></div>
          </div>

          <table className="nfp-print-table">
            <tbody>
              <tr>
                <td className="nfp-print-label">Student Name</td>
                <td>{studentProfile?.student_full_name || "-"}</td>
                <td className="nfp-print-label">Roll No.</td>
                <td>{studentProfile?.Roll_Number || "-"}</td>
              </tr>
              <tr>
                <td className="nfp-print-label">Course / Batch</td>
                <td className="nfp-print-wrap">
                  {studentProfile?.Course_Name || "-"} / {studentProfile?.Batch || "-"}
                </td>
                <td className="nfp-print-label">Session</td>
                <td>{selectedSession?.session_name || studentProfile?.session || "-"}</td>
              </tr>
              <tr>
                <td className="nfp-print-label">Statement Date</td>
                <td>{printDate}</td>
                <td className="nfp-print-label">Status</td>
                <td>{studentProfile?.status || "-"}</td>
              </tr>
            </tbody>
          </table>

          <table className="nfp-print-table">
            <colgroup>
              <col style={{ width: "14%" }} />
              <col style={{ width: "11%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "11%" }} />
              <col style={{ width: "11%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "11%" }} />
            </colgroup>
            <thead>
              <tr>
                <th>Particulars</th>
                <th>Total Base Fee</th>
                <th>Scholarship</th>
                <th>Concession</th>
                <th>Net Fee</th>
                <th>SGST ({defaultSgst || 0}%)</th>
                <th>CGST ({defaultCgst || 0}%)</th>
                <th>Total GST</th>
                <th>Final Fee Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Coaching Fee</td>
                <td>₹ {formatINR(totalFee)}</td>
                <td>₹ {formatINR(scholarship)}</td>
                <td>₹ {formatINR(discount)}</td>
                <td>₹ {formatINR(netFeeBase)}</td>
                <td>₹ {formatINR(sgstAmount)}</td>
                <td>₹ {formatINR(cgstAmount)}</td>
                <td>₹ {formatINR(totalGstAmount)}</td>
                <td>
                  <strong>₹ {formatINR(netFee)}</strong>
                </td>
              </tr>
            </tbody>
          </table>

          <table className="nfp-print-table">
            <colgroup>
              <col style={{ width: "6%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "11%" }} />
              <col style={{ width: "11%" }} />
              <col style={{ width: "11%" }} />
              <col style={{ width: "13%" }} />
              <col style={{ width: "15%" }} />
            </colgroup>
            <thead>
              <tr>
                <th>Inst. No</th>
                <th>Due Date</th>
                <th>Inst Amount</th>
                <th className="nfp-print-nowrap">%</th>
                <th>SGST</th>
                <th>CGST</th>
                <th>Total GST</th>
                <th>Gross Inst Amount</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {installments.map((inst) => {
                const instAmount = Number(inst.amount) || 0;
                const breakup = installmentTaxBreakup(instAmount, defaultSgst, defaultCgst);
                return (
                  <tr key={inst.key}>
                    <td>{inst.installment_no}</td>
                    <td>{formatDisplayDate(inst.due_date, "-")}</td>
                    <td className="nfp-print-nowrap">₹ {formatINR(instAmount)}</td>
                    <td className="nfp-print-nowrap">{derivePercentage(inst.amount, netFeeBase) || 0}%</td>
                    <td>₹ {formatINR(breakup.sgst)}</td>
                    <td>₹ {formatINR(breakup.cgst)}</td>
                    <td>₹ {formatINR(breakup.totalGst)}</td>
                    <td>₹ {formatINR(breakup.grossAmount)}</td>
                    <td className="nfp-remarks-cell">{inst.remarks || "-"}</td>
                  </tr>
                );
              })}
              <tr className="nfp-print-total-row">
                <td colSpan={2}>Total</td>
                <td className="nfp-print-nowrap">₹ {formatINR(installmentTotals.instAmount)}</td>
                <td></td>
                <td>₹ {formatINR(installmentTotals.sgst)}</td>
                <td>₹ {formatINR(installmentTotals.cgst)}</td>
                <td>₹ {formatINR(installmentTotals.totalGst)}</td>
                <td>₹ {formatINR(installmentTotals.grossAmount)}</td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <div className="nfp-print-remarks">
            <div>
              <strong>Approved By:</strong> {approvedBy || "-"}
            </div>
            <div>
              <strong>Remarks:</strong> {remarks || "-"}
            </div>
          </div>

          <div className="nfp-print-footer">
            <div>Generated by: {employeeName || "-"}</div>
            {showSignature && <div>Parent/Guardian Signature</div>}
            <div>Printed on: {printDate}</div>
          </div>
        </div>
        </div>
        ))}
      </div>
    </div>
  );
}

export default EditFeePlan;